/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 발급 대기
 * `issued` - 발급 완료
 * `rejected` - 반려
 */
export type TaxInvoiceStatusEnum =
  (typeof TaxInvoiceStatusEnum)[keyof typeof TaxInvoiceStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaxInvoiceStatusEnum = {
  pending: "pending",
  issued: "issued",
  rejected: "rejected",
} as const;
